import { PayloadAction } from '@reduxjs/toolkit'
import { SagaIterator } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects'
import { convertISTToLocal } from '../../helpers/Timezone'
import { GET_RECORDED_DATA } from './actionTypes'
import { getRecordedData } from './api'
import {
  GetRecordedDataActionType,
  addPatientRecordedData,
  errorPatientRecordedData,
} from './recordedDataReducer'
import { PatientRecordedDataEntityType, PatientRecordedDataType } from './types'

export function* handlePatientRecordedData(
  actions: PayloadAction<GetRecordedDataActionType>
): SagaIterator<void> {
  try {
    const response = yield call(
      getRecordedData,
      actions.payload.patientKey,
      actions.payload.startTime,
      actions.payload.endTime
    )
    const { data } = response
    let modifiedData: PatientRecordedDataEntityType = {
      key: actions.payload.patientKey,
      patientRecordedData: data.sensorData
    }
    yield put(addPatientRecordedData(modifiedData))
  } catch (error: any) {
    yield put(errorPatientRecordedData(error.response.data.message))
  }
}

export function* watcherSaga() {
  yield takeLatest(GET_RECORDED_DATA, handlePatientRecordedData)
}

export const recordedDataSaga = [fork(watcherSaga)]
